import { Controller } from "stimulus"

// import Chart from 'chart.js/auto';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// Chart.register(ChartDataLabels);

export default class extends Controller {
  static targets = ["qrElement"];
  connect() {
    console.log("Animated QR controller connected!");
    this.requestOpts = this.element.dataset;
    this.fetchTokenAndUpdateQRRepeatedly();
  }

  fetchTokenAndUpdateQRRepeatedly() {
    // This is just the first QR code on page load, then we need to get new tokens continually
    // The first QR will probably be useless by the time it's show, so not really much point in doing this
    // It's just here to show how it's done. When we have a live bank id thing, we probably want to make
    // a request to update the token immediately.
    this.qrElementTarget.innerHTML = '';
    new QRCode(this.qrElementTarget, this.requestOpts.initialLink);

    // Rails.ajax({
    //   type: 'GET',
    //   url: this.requestOpts.endpoint,
    //   //data: new FormData(signupForm),
    //   success: function(response) {
    //     console.log(response);
    //     this.qrElementTarget.innerHTML = '';
    //     new QRCode(this.qrElementTarget, (Math.floor(Math.random() * 1000000000)).toString());
    //   },
    //   error: function(response, status, request) { }
    // });

    //console.log(this.requestOpts);
    //setTimeout(this.fetchTokenAndUpdateQRRepeatedly.bind(this), 500);

    // fetch(this.requestOpts.endpoint, { method:"GET", headers: { 
    //     //"Access-Control-Allow-Origin": "api.sandbox.openbankingplatform.com",
    //     "Access-Control-Allow-Origin": "192.168.88.15:3000",
    //     "Accept": "application/json",
    //     "Authorization": "Bearer " + this.requestOpts.accessToken,
    //     "Content-Type": "application/json",
    //     "PSU-IP-Address": this.requestOpts.psuIpAddress,
    //     "X-BicFi": this.requestOpts.bic,
    //     "X-Request-ID": this.requestOpts.requestId // We might want to generate a uuid request id here, but then how would we log it?
    //   }}).then(function onRes(res){
    //      if (res && res.ok) {
    //         new QRCode(this.qrElementTarget, (Math.floor(Math.random() * 1000000000)).toString());
    //      }
    //   });

    //setTimeout(this.fetchTokenAndUpdateQRRepeatedly.bind(this), 500);
  }
}